export default {
    //顺时针旋转90度
    rotate(dataUrl) {
        return new Promise(function(resolve, reject) {
        try {
            let srcImg = new Image();
            srcImg.src = dataUrl;
            srcImg.onload = function() {
                let width = srcImg.width;
                let height = srcImg.height;                 
                let dstCanvas = document.createElement("canvas");
                dstCanvas.width = height;
                dstCanvas.height = width;

                let ctx = dstCanvas.getContext("2d");
                ctx.clearRect(0, 0, dstCanvas.width, dstCanvas.height);
                ctx.translate(dstCanvas.width/2, dstCanvas.height/2);
                ctx.rotate(Math.PI/2);
                ctx.drawImage(srcImg, -srcImg.width/2, -srcImg.height/2);

                let photo = dstCanvas.toDataURL("image/png");
                
                resolve({
                    width: dstCanvas.width,
                    height: dstCanvas.height,
                    photo: photo
                });
            };
        } catch (error) {
            reject(error);
        }
        });
    },
    // rotate(dataUrl) {
    //     return new Promise(function(resolve, reject) {
    //     try {
    //         let srcImg = new Image();
    //         srcImg.src = dataUrl;
    //         srcImg.onload = function() {
    //             let dstCanvas = document.createElement("canvas");
    //             let width = srcImg.width;
    //             let height = srcImg.height;
    //             let dstCanvasHeight = srcImg.height>srcImg.width?srcImg.height:srcImg.width;
    //             let height2=dstCanvasHeight/2;
    //             dstCanvas.width = height;
    //             dstCanvas.height = width;
    //             let ctx = dstCanvas.getContext("2d");
    //             ctx.translate(height2, height2);//正方形画板 
    //             ctx.rotate(90* Math.PI / 180);
    //             ctx.drawImage(srcImg, height2*-1,height2*-1);
    //             let photo = dstCanvas.toDataURL("image/png");
    //             resolve({
    //                 width: dstCanvas.width,
    //                 height: dstCanvas.height,
    //                 photo: photo
    //             });
    //         };
    //     } catch (error) {
    //         reject(error);
    //     }
    //     });
    // },
    async resize(dataUrl, maxWidth, maxHeight) {
        return new Promise( function (resolve, reject) {
            try {
                let srcImg = new Image();
                srcImg.src = dataUrl;
                srcImg.onload =async function () {
                    let dstCanvas = document.createElement("canvas");
                    //适配横向纵向
                    if((maxWidth > maxHeight) !== (srcImg.width > srcImg.height)){
                        //图片展示方向（横向或纵向）与压缩后的展示方向（横向或纵向）不符，调整压缩后的展示方向
                        var mw = maxWidth;
                        maxWidth = maxHeight;
                        maxHeight = mw;
                    }
                    let width = srcImg.width;
                    let height = srcImg.height;

                    //横向图，优先适配宽度，高度按比例缩放，
                    if (srcImg.width > srcImg.height) {
                        width = width > maxWidth ? maxWidth : width;
                        height = width / srcImg.width * srcImg.height;
                    } else {
                        //纵向图，优先适配高度，宽度按比例缩放，
                        height = height > maxHeight ? maxHeight : height;
                        width = height / srcImg.height * srcImg.width;
                    }
                    dstCanvas.width = width;
                    dstCanvas.height = height;
                    let ctx = dstCanvas.getContext('2d');
                    ctx.drawImage(srcImg, 0, 0, dstCanvas.width, dstCanvas.height);
                    let photo = dstCanvas.toDataURL("image/jpeg");
                    resolve({
                        width: dstCanvas.width,
                        height: dstCanvas.height,
                        photo: photo
                    });
                };
            }
            catch (error) {
                reject(error);
            }
        });
    },
}